import React from "react";
import { Licence } from "./licence";
import { Img } from "./style";

const CCLicence = ({ license = null }) => {
  // TODO: refactor this, standalone component with ts and no dependencies?
  switch (license) {
    case "CC-BY-4.0": {
      return (
        <Licence
          licenceImage={
            <Img
              alt="Creative Commons License"
              src="https://i.creativecommons.org/l/by/4.0/88x31.png"
              width="88"
              height="33"
            />
          }
          textLink={
            <>
              This work is licensed under a{" "}
              <a
                rel="license"
                href="http://creativecommons.org/licenses/by/4.0/"
              >
                Creative Commons Attribution 4.0 International License.
              </a>
            </>
          }
        />
      );
    }
    case "CC-BY-SA-4.0": {
      return (
        <Licence
          licenceImage={
            <Img
              alt="Creative Commons License"
              src="https://i.creativecommons.org/l/by-sa/4.0/88x31.png"
              width="88"
              height="33"
            />
          }
          textLink={
            <>
              This work is licensed under a{" "}
              <a
                rel="license"
                href="http://creativecommons.org/licenses/by-sa/4.0/"
              >
                Creative Commons Attribution-ShareAlike 4.0 International
                License.
              </a>
            </>
          }
        />
      );
    }
    case "CC-BY-NC-4.0": {
      return (
        <Licence
          licenceImage={
            <Img
              alt="Creative Commons License"
              src="https://i.creativecommons.org/l/by-nc/4.0/88x31.png"
              width="88"
              height="33"
            />
          }
          textLink={
            <>
              This work is licensed under a{" "}
              <a href="http://creativecommons.org/licenses/by-nc/4.0/">
                Creative Commons Attribution-NonCommercial 4.0 International
                License.
              </a>
            </>
          }
        />
      );
    }
    case "CC-BY-NC-SA-4.0": {
      return (
        <Licence
          textLink={
            <>
              <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">
                <Img
                  alt="Creative Commons License"
                  src="https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
                  width="88"
                  height="33"
                />
              </a>
              <br />
              This work is licensed under a{" "}
              <a
                rel="license"
                href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
              >
                Creative Commons Attribution-NonCommercial-ShareAlike 4.0
                International License.
              </a>
            </>
          }
        />
      );
    }
    default: {
      // unknown
      return null;
    }
  }
};
export default React.memo(CCLicence);
